import { render, staticRenderFns } from "./auth-captcha.vue?vue&type=template&id=cf4ddd5a&"
import script from "./auth-captcha.vue?vue&type=script&lang=js&"
export * from "./auth-captcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports